/**
 * Gmail-faithful palette. Source: web.gmail.com inspector, plus Google's
 * Material Symbols guidance. Keep this feature visually independent from
 * Xale's green app chrome.
 */
export const GMAIL_TOKENS = {
  bg: "#f6f8fc",
  card: "#ffffff",
  hairline: "#e0e3e7",
  rowHover: "#f2f6fc",
  rowSelected: "#c2e7ff",
  rowSelectedHover: "#b4dffd",
  unread: "#202124",
  read: "#5f6368",
  snippet: "#5f6368",
  link: "#1a73e8",
  linkHover: "#1558c5",
  divider: "#dadce0",
  iconMuted: "#5f6368",
  iconActive: "#202124",
  badgeRed: "#d93025",
  badgeAmber: "#f9ab00",
  badgeGreen: "#188038",
  gmailRed: "#ea4335",
  gmailBlue: "#1a73e8",
  gmailLightBlue: "#c2e7ff",
  gmailLightBlueHover: "#b4dffd",
  composeBg: "#c2e7ff",
  composeBgHover: "#b4dffd",
  composeFg: "#001d35",
  actionBg: "#1a73e8",
  actionBgHover: "#1558c5",
  actionFg: "#ffffff",
  /** Outer wrapper height; --screen-h cancels the global body zoom, respects --header-height. */
  shellHeight: "calc(var(--screen-h, 100vh) - var(--header-height))",
} as const;

export const GMAIL_FONT_STACK =
  "'Google Sans', 'Helvetica Neue', Arial, sans-serif";
